import { ActionButton } from "@/dev/ui/verify-footer";
import { useMyDataContext } from "@/hooks/context/useMyDataContext";

const CancelFooter = () => {
  const { onCancel, onConfirm, actionDisabled } = useMyDataContext();
  return (
    <footer className="flex flex-col gap-4 h-fit justify-center mt-8 w-full ">
      <div className="sm:flex-row flex-col items-center flex w-full justify-center ">
        <ActionButton color="gray" onClick={onConfirm} disabled={actionDisabled}>
          <span className="text-lg">ביטול קבלת מיילים</span>
        </ActionButton>
        <ActionButton onClick={onCancel} disabled={actionDisabled}>
          <span className="text-lg">להשאר מחובר לשירות</span>
        </ActionButton>
      </div>
      <center>
        <p className="text-sm text-gray-500 mt-8">תוכל לחזור ולהירשם בכל עת דרך הגדרות החשבון שלך</p>
      </center>
    </footer>
  );
};
export default CancelFooter;
